var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"button is-dark is-outlined is-small",attrs:{"title":_vm.item.id == 0 ? 'Display scene details': 'Edit scene details'},on:{"click":function($event){return _vm.editScene(_vm.item)}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":"lead-pencil","size":"is-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }